export default __webpack_public_path__ + "2b15df6f0ac41825553a8fcd72d542ae.png";